// extracted by mini-css-extract-plugin
module.exports = {"container":"CmSectionMovie_container__tTa_A","label":"CmSectionMovie_label__Yhg2m","text":"CmSectionMovie_text__3AwoJ"};